import { Controller } from "@hotwired/stimulus";
import flatpickr from 'flatpickr';
import { French } from "flatpickr/dist/l10n/fr.js";

// Connects to data-controller="datetime-picker" on a text input.
// Readable French date and 24h time in the field, ISO value (Y-m-dTH:i) sent with the form.
export default class extends Controller {
  connect() {
    this.picker = flatpickr(this.element, {
      locale: French,
      enableTime: true,
      time_24hr: true,
      allowInput: true,
      altInput: true,
      altFormat: 'j F Y à H:i',
      dateFormat: 'Y-m-d\\TH:i',
      minuteIncrement: 5,
    });
  }

  disconnect() {
    this.picker?.destroy();
  }
}
